import { define, c } from '@components/Component.js'
import { h } from '@core/dom.js'
import { uiIcons } from '@/shared/brandIcons.js'
import { waLink } from '@/shared/utils/whatsapp.js'
import { getReviewStats, getBusinessStats } from '@/services/reviewStats.js'

define('GoldPage', ({ business }) => {
    const {
        id, name, fullDescription,
        catalog, gallery,
        mapEmbed, mapLabel, mapUrl,
        whatsapp, open, views
    } = business

    /* ── Stats row ── */
    const ratingValue = h('div', { className: 'gold-stat__value' }, '--')
    const ratingLabel = h('div', { className: 'gold-stat__label' }, '0 reseñas')
    getReviewStats().then(stats => {
        const s = getBusinessStats(stats, id)
        ratingValue.textContent = s.avg ? String(s.avg) : '--'
        ratingLabel.textContent = s.count + ' reseña' + (s.count !== 1 ? 's' : '')
    })

    const viewsValue = h('div', { className: 'gold-stat__value' }, String(views || 0))
    fetch('/api/stats.php').then(r => r.json()).then(stats => {
        const phpClicks = stats[`business:${id}`] || 0
        viewsValue.textContent = String((views || 0) + phpClicks)
    }).catch(() => {})

    const statsRow = h('div', { className: 'gold-stats' },
        h('div', { className: 'gold-stat' },
            h('div', { className: 'gold-stat__icon', style: 'color: #f59e0b' }, '★'),
            ratingValue,
            ratingLabel
        ),
        h('div', { className: 'gold-stat' },
            h('div', { className: 'gold-stat__icon', style: 'color: var(--color-primary)' }, '⏰'),
            h('div', { className: 'gold-stat__value' }, open ? 'Abierto' : 'Cerrado'),
            h('div', { className: 'gold-stat__label' }, 'Horario')
        ),
        h('div', { className: 'gold-stat' },
            h('div', { className: 'gold-stat__icon', style: 'color: #6366f1' }, '👁'),
            viewsValue,
            h('div', { className: 'gold-stat__label' }, 'Visitas')
        ),
        h('div', { className: 'gold-stat' },
            h('div', { className: 'gold-stat__icon', style: 'color: #b7791f' }, '✔'),
            h('div', { className: 'gold-stat__value' }, 'Verificado'),
            h('div', { className: 'gold-stat__label' }, 'Negocio real')
        )
    )

    /* ── Descripción ── */
    const aboutCard = h('div', { className: 'gold-card' },
        h('h2', { className: 'gold-section__title' }, 'Sobre este negocio'),
        h('p', { className: 'gold-about__text' }, fullDescription)
    )

    /* ── Catálogo ── */
    const catalogCard = catalog
        ? h('div', { className: 'gold-card' },
            h('h2', { className: 'gold-section__title' }, 'Catálogo PDF'),
            h('div', { className: 'gold-catalog__file' },
                h('span', { className: 'gold-catalog__icon' }, '📄'),
                h('div', { className: 'gold-catalog__info' },
                    h('strong', {}, catalog.label),
                    h('p', { className: 'gold-catalog__desc' }, catalog.description)
                )
            ),
            h('div', { className: 'gold-catalog__actions' },
                h('a', {
                    href:      catalog.url,
                    target:    '_blank',
                    rel:       'noopener',
                    className: 'gold-btn gold-btn--primary'
                }, 'Ver catálogo'),
                h('a', {
                    href:      catalog.url,
                    download:  true,
                    className: 'gold-btn gold-btn--outline'
                }, 'Descargar PDF')
            )
        )
        : null

    const row2 = h('div', { className: 'gold-row gold-row--2' },
        aboutCard,
        catalogCard
    )

    /* ── Galería ── */
    const galleryCard = (gallery && gallery.length)
        ? h('div', { className: 'gold-card' },
            h('h2', { className: 'gold-section__title' }, 'Galería premium'),
            c('GoldGallery', { gallery, name })
        )
        : null

    /* ── Ubicación ── */
    const locationCard = h('div', { className: 'gold-card' },
        h('h2', { className: 'gold-section__title' }, 'Ubicación'),
        mapEmbed
            ? h('div', { className: 'gold-map__wrap' },
                h('iframe', {
                    src:             mapEmbed,
                    className:       'gold-map__iframe',
                    frameborder:     '0',
                    allowfullscreen: true,
                    loading:         'lazy',
                    title:           'Mapa'
                })
            )
            : null,
        h('p', { className: 'gold-map__label', innerHTML: uiIcons.pin + ' ' + mapLabel }),
        h('a', {
            href:      mapUrl,
            target:    '_blank',
            rel:       'noopener',
            className: 'gold-btn gold-btn--primary gold-btn--sm',
            innerHTML: uiIcons.map + ' Cómo llegar'
        })
    )

    /* ── Promo ── */
    const promoCard = h('div', { className: 'gold-card gold-promo' },
        h('div', { className: 'gold-promo__banner' },
            h('div', { className: 'gold-promo__text' },
                h('h3', { className: 'gold-promo__title' }, 'Publicidad destacada desde la app UBIYAAA'),
                h('p', { className: 'gold-promo__desc' },
                    'Este negocio cuenta con presencia destacada dentro de UBIYAAA para ganar mayor visibilidad local.'
                )
            ),
            h('div', { className: 'gold-promo__icons' },
                h('span', {}, '📱'),
                h('span', {}, '📣')
            )
        ),
        h('div', { className: 'gold-cta' },
            h('p', { className: 'gold-cta__question' }, `¿Quieres contactar este negocio?`),
            h('p', { className: 'gold-cta__sub' }, 'Hazlo fácil y rápido desde WhatsApp.'),
            h('a', {
                href:      waLink(whatsapp),
                target:    '_blank',
                rel:       'noopener',
                className: 'gold-cta__btn',
                innerHTML: uiIcons.whatsapp + ' Contactar por WhatsApp'
            })
        )
    )

    const row3Children = [locationCard, promoCard]
    if (galleryCard) row3Children.unshift(galleryCard)

    const row3 = h('div', {
        className: galleryCard ? 'gold-row gold-row--3' : 'gold-row gold-row--2'
    }, ...row3Children)

    return h('div', { className: 'biz-gold' },
        c('GoldHero', { business }),
        h('div', { className: 'biz-gold__inner' },
            statsRow,
            row2,
            row3,
            c('BusinessReviews', { businessId: business.id })
        )
    )
})
